import React, { useState, useEffect, useMemo } from "react";
import { Form, Col, Row, InputGroup, OverlayTrigger, Tooltip, Tabs, Tab, Toast, Badge } from "react-bootstrap";
import { registerLocale } from 'react-datepicker';
import DashMedidasButton, { DashMedidasButtonGroup } from "./DashMedidasButton/DashMedidasButton";
import PdfDownloader from "./PdfDownloader";
import { buildDashMedidasExportContext } from "../utils/buildDashMedidasExportContext";
import { BsArrowCounterclockwise, BsBoxArrowUpRight, BsFilter } from "react-icons/bs";
import { FaFileContract, FaIdCard, FaTruck, FaBoxes, FaCalendarAlt, FaSearch } from "react-icons/fa";
import DashMedidasSectionCard from "./DashMedidasSectionCard/DashMedidasSectionCard";
import "react-datepicker/dist/react-datepicker.css";

import pt from 'date-fns/locale/pt';
registerLocale('pt', pt);

const InsertDate = (props) => {
  const {
    user,
    getMaxDate,
    getMinDate,
    arrayEquips,
    curvas,
    handleChange,
    curvaSelecionada,
    permissionSGU,
    empresa,
    handleGetPeriod,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    ultimoClicado,
    setShow,
    handleClearFilters,
    hasActiveFilters,
    isLoader,
    id,
    filterData, // Receber o estado filterData do componente pai
    applyTypeFilter, // Receber a função de filtro do componente pai
    measuresLength = 60,
    onMeasuresLengthApply,
    isMeasuresLengthEnabled = true,
    maxMeasuresLength = 60,
  } = props;

  const [lastData, setLastData] = useState(7);
  const [measuresLengthDraft, setMeasuresLengthDraft] = useState(String(measuresLength));

  const [customFilter, setCustomFilter] = useState({
    contrato: "",
    cnpj: "",
    lote: "",
    placa: "",
  });

  const [showToast, setShowToast] = useState(false);
  const [lastCurva, setLastCurva] = useState('');

  const exportContext = useMemo(
    () => buildDashMedidasExportContext(arrayEquips),
    [arrayEquips]
  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomFilter(prevFilter => ({ ...prevFilter, [name]: value }));
  };

  const handleApplyFilters = () => {
    if (!customFilter.contrato && !customFilter.cnpj && !customFilter.lote && !customFilter.placa) {
      alert("Todos os campos estão vazios");
      return;
    }
    handleGetPeriod(lastData, ultimoClicado, filterData, customFilter);
  };

  const handleChangeStartDate = (event) => {
    // Importante preservar o formato correto da data
    const valor = event.target.value;
    // Não modificar o formato, apenas passar o valor para o setter
    setStartDate(valor);
  };

  const handleChangeEndDate = (event) => {
    // Importante preservar o formato correto da data
    const valor = event.target.value;
    // Não modificar o formato, apenas passar o valor para o setter
    setEndDate(valor);
  };

  const handleCurvaChange = (event) => {
    handleChange(event);
  };

  const handlePeriodClick = (days, ultimoClicadoIndex) => {
    setLastData(days);
    setStartDate(null);
    setEndDate(null);
    // Chama handleGetPeriod com startDate e endDate null no customFilter
    handleGetPeriod(
      days,
      ultimoClicadoIndex,
      filterData,
      { ...customFilter, startDate: null, endDate: null }
    );
  };

  useEffect(() => {
    // Monitorar mudanças na curva selecionada
    if (curvaSelecionada && curvaSelecionada !== lastCurva) {
      setShowToast(true);
      setLastCurva(curvaSelecionada);
    }
  }, [curvaSelecionada]);

  function diasNosMeses(meses) {
    const hoje = new Date();
    const dataAtras = new Date(hoje.getFullYear(), hoje.getMonth() - meses, hoje.getDate());
    const diferencaEmMilissegundos = hoje - dataAtras;
    const diferencaEmDias = diferencaEmMilissegundos / (1000 * 60 * 60 * 24);
    return diferencaEmDias.toFixed(0) - 1;
  }

  const quantidadeDeDiasUmMes = diasNosMeses(1);
  const quantidadeDeDiasTresMeses = diasNosMeses(3);
  const quantidadeDeDiasSeisMeses = diasNosMeses(6);

  const hasAdvancedFilterDraft = Object.values(customFilter).some((value) =>
    String(value).trim()
  );

  useEffect(() => {
    if (!hasActiveFilters) {
      applyTypeFilter("all");
    }
  }, []);

  useEffect(() => {
    setMeasuresLengthDraft(String(measuresLength));
  }, [measuresLength]);

  const commitMeasuresLength = () => {
    if (!isMeasuresLengthEnabled) return;
    if (typeof onMeasuresLengthApply === "function") {
      onMeasuresLengthApply(measuresLengthDraft);
    }
  };

  const handleMeasuresLengthChange = (event) => {
    const { value } = event.target;
    if (value === "") {
      setMeasuresLengthDraft("");
      return;
    }

    const parsed = Number.parseInt(value, 10);
    if (Number.isFinite(parsed) && parsed > maxMeasuresLength) {
      setMeasuresLengthDraft(String(maxMeasuresLength));
      return;
    }

    setMeasuresLengthDraft(value);
  };

  const handleMeasuresLengthKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      commitMeasuresLength();
    }
  };

  const headerRightContent = (
    <div className="d-flex align-items-center gap-2 flex-wrap justify-content-end">
      <div className="d-flex flex-column align-items-end gap-1">
        <span className="dash-section-card__header-meta dash-header-empresa text-truncate">
          {user?.hideSensitiveInfo ? "*****" : empresa ? empresa.toUpperCase() : ""}
        </span>
        {hasActiveFilters && (
          <Badge bg="success" pill className="d-flex align-items-center" style={{ fontSize: "0.7rem" }}>
            <BsFilter className="me-1" /> Filtros ativos
          </Badge>
        )}
      </div>
      <PdfDownloader
        user={user}
        empresa={empresa}
        serialnumber={id}
        data={exportContext.data}
        limits={exportContext.limits}
        stats={exportContext.stats}
        mean={exportContext.mean}
        weight={exportContext.weight}
        weightStats={exportContext.weightStats}
        curvaSelecionada={curvaSelecionada}
        permissionSGU={permissionSGU}
        buttonLabel="Download"
        toggleId="dash-filtros-download-toggle"
      />
    </div>
  );

  return (
    <>
      <Toast
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
        style={{
          position: 'fixed',
          top: 20,
          right: 20,
          minWidth: '200px',
          zIndex: 9999,
          backgroundColor: '#8fad15',
          color: 'white',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
        }}
      >
        <Toast.Body className="d-flex align-items-center">
          <span className="me-2">✓</span> Curva selecionada: <strong className="ms-1">{curvaSelecionada}</strong>
        </Toast.Body>
      </Toast>

      <DashMedidasSectionCard
        icon={BsFilter}
        subtitle="Consulta"
        title="Filtros"
        headerRight={headerRightContent}
        collapsible
        sectionId="dash-filtros"
      >
      <div className="dash-section-card__content-stack">
      <Row className="dash-medidas-grid align-items-center">
        <Col xs={12} md={6} lg={4}>
          <div className="d-flex gap-2 align-items-center dash-filter-field h-100">
            <InputGroup size="sm" className="flex-grow-1">
              <InputGroup.Text className="bg-white text-secondary border-end-0">
                <FaSearch size={12} />
              </InputGroup.Text>
              <Form.Control
                size="sm"
                placeholder={`Equip: ${id}`}
                disabled
                className="bg-white border-start-0"
                style={{ fontWeight: '500' }}
              />
            </InputGroup>
          </div>
        </Col>
        <Col xs={12} md={6} lg={4}>
          <div className="dash-filter-field h-100">
            <InputGroup size="sm">
              <InputGroup.Text className="py-0 px-2 bg-white text-secondary">Tipo de grão</InputGroup.Text>
              <Form.Select
                size="sm"
                value={curvaSelecionada}
                onChange={handleCurvaChange}
                disabled={isLoader || !permissionSGU?.home?.write}
                className={curvas.length > 0 ? "border-success" : ""}
                style={{ fontWeight: '500' }}
              >
                <option value="">Todos</option>
                {curvas.map((curva, i) => (
                  <option key={i} value={curva}>{curva}</option>
                ))}
              </Form.Select>
            </InputGroup>
          </div>
        </Col>
        <Col xs={12} md={12} lg={4}>
          <div className="d-flex gap-2 justify-content-lg-end align-items-center flex-wrap dash-filter-field dash-filtros-actions h-100">
            <DashMedidasButton
              variant={hasActiveFilters ? "outline-danger" : "light"}
              onClick={handleClearFilters}
              disabled={!permissionSGU?.home?.write}
              className={!hasActiveFilters ? "dash-btn--muted" : ""}
            >
              <BsArrowCounterclockwise /> Limpar
            </DashMedidasButton>
            <DashMedidasButton
              variant="warning"
              onClick={() => setShow(true)}
              disabled={!permissionSGU?.home?.write}
            >
              <BsBoxArrowUpRight /> Analisar dados
            </DashMedidasButton>
          </div>
        </Col>
      </Row>

      <Tabs
        defaultActiveKey="period"
        className="dash-medidas-tabs"
        variant="pills"
      >
        <Tab
          eventKey="period"
          title={
            <span className="dash-medidas-tab-label">
              <FaCalendarAlt className="dash-medidas-tab-icon" aria-hidden />
              Período
            </span>
          }
        >
          <div className="dash-filtros-tab-panel dash-filtros-tab-panel--period pt-1">
            <div className="dash-filtros-period-toolbar d-flex gap-2 flex-wrap align-items-center">
              <div className="dash-filtros-period-groups d-flex flex-wrap gap-2 align-items-center">
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip>
                    {isMeasuresLengthEnabled
                      ? `Quantidade de medidas (máx. ${maxMeasuresLength})`
                      : "Disponível apenas quando nenhum outro filtro estiver ativo"}
                  </Tooltip>
                }
              >
                <InputGroup
                  size="sm"
                  className={[
                    "dash-measures-length-input",
                    !isMeasuresLengthEnabled ? "dash-measures-length-input--disabled" : "",
                  ]
                    .filter(Boolean)
                    .join(" ")}
                >
                  <InputGroup.Text className="py-0 bg-light text-secondary">Medidas</InputGroup.Text>
                  <Form.Control
                    type="number"
                    min={1}
                    max={maxMeasuresLength}
                    size="sm"
                    value={measuresLengthDraft}
                    onChange={handleMeasuresLengthChange}
                    onBlur={commitMeasuresLength}
                    onKeyDown={handleMeasuresLengthKeyDown}
                    disabled={!permissionSGU?.home?.write || !isMeasuresLengthEnabled}
                    aria-label="Quantidade de medidas"
                  />
                </InputGroup>
              </OverlayTrigger>
              <DashMedidasButtonGroup className="dash-btn-group--responsive">
                <DashMedidasButton
                  onClick={() => handlePeriodClick(1, 0)}
                  variant={ultimoClicado === 0 ? "success" : "outline-success"}
                  disabled={!permissionSGU?.home?.write}
                >
                  1 dia
                </DashMedidasButton>
                <DashMedidasButton
                  onClick={() => handlePeriodClick(7, 1)}
                  variant={ultimoClicado === 1 ? "success" : "outline-success"}
                  disabled={!permissionSGU?.home?.write}
                >
                  7 dias
                </DashMedidasButton>
                <DashMedidasButton
                  onClick={() => handlePeriodClick(quantidadeDeDiasUmMes, 2)}
                  variant={ultimoClicado === 2 ? "success" : "outline-success"}
                  disabled={!permissionSGU?.home?.write}
                >
                  1 mês
                </DashMedidasButton>
                <DashMedidasButton
                  onClick={() => handlePeriodClick(quantidadeDeDiasTresMeses, 3)}
                  variant={ultimoClicado === 3 ? "success" : "outline-success"}
                  disabled={!permissionSGU?.home?.write}
                >
                  3 meses
                </DashMedidasButton>
                <DashMedidasButton
                  onClick={() => handlePeriodClick(quantidadeDeDiasSeisMeses, 4)}
                  variant={ultimoClicado === 4 ? "success" : "outline-success"}
                  disabled={!permissionSGU?.home?.write}
                >
                  6 meses
                </DashMedidasButton>
              </DashMedidasButtonGroup>
              <DashMedidasButtonGroup className="dash-btn-group--responsive dash-filtros-type-group">
                <OverlayTrigger placement="top" overlay={<Tooltip>Mostrar todos os registros</Tooltip>}>
                  <DashMedidasButton
                    onClick={() => applyTypeFilter("all")}
                    variant={filterData === "all" ? "secondary" : "outline-secondary"}
                    disabled={!permissionSGU?.home?.write}
                  >
                    Tudo
                  </DashMedidasButton>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip>Filtrar entradas (umidade &gt; 14,5%)</Tooltip>}>
                  <DashMedidasButton
                    onClick={() => applyTypeFilter("input")}
                    variant={filterData === "input" ? "secondary" : "outline-secondary"}
                    disabled={!permissionSGU?.home?.write}
                  >
                    Entradas
                  </DashMedidasButton>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip>Filtrar saídas (umidade &lt; 14,5%)</Tooltip>}>
                  <DashMedidasButton
                    onClick={() => applyTypeFilter("output")}
                    variant={filterData === "output" ? "secondary" : "outline-secondary"}
                    disabled={!permissionSGU?.home?.write}
                  >
                    Saídas
                  </DashMedidasButton>
                </OverlayTrigger>
              </DashMedidasButtonGroup>
              </div>

              <div className="dash-filtros-date-range d-flex flex-nowrap gap-2">
                <InputGroup size="sm" className="dash-date-input">
                  <InputGroup.Text className="py-0 bg-light">De</InputGroup.Text>
                  <Form.Control
                    type="date"
                    size="sm"
                    value={startDate || ''}
                    onChange={handleChangeStartDate}
                    disabled={!permissionSGU?.home?.write}
                    className="text-success"
                    min={getMinDate()}
                    max={getMaxDate()}
                  />
                </InputGroup>
                <InputGroup size="sm" className="dash-date-input">
                  <InputGroup.Text className="py-0 bg-light">Até</InputGroup.Text>
                  <Form.Control
                    type="date"
                    size="sm"
                    value={endDate || ''}
                    onChange={handleChangeEndDate}
                    disabled={!permissionSGU?.home?.write}
                    className="text-success"
                    min={getMinDate()}
                    max={getMaxDate()}
                  />
                </InputGroup>
              </div>
            </div>
          </div>
        </Tab>

        <Tab
          eventKey="advanced"
          title={
            <span className="dash-medidas-tab-label">
              <BsFilter className="dash-medidas-tab-icon" aria-hidden />
              Filtros avançados
              {hasAdvancedFilterDraft && (
                <span className="dash-medidas-tab-badge" aria-hidden />
              )}
            </span>
          }
        >
          <div className="dash-filtros-tab-panel dash-filtros-tab-panel--advanced pt-1">
            <div className="dash-filtros-advanced d-flex gap-2 flex-wrap align-items-center">
              <InputGroup size="sm" className="dash-filter-input-group shadow-sm">
                <InputGroup.Text className="py-0 bg-light text-secondary"><FaFileContract size={12} /></InputGroup.Text>
                <Form.Control
                  size="sm"
                  type="text"
                  name="contrato"
                  value={customFilter.contrato}
                  onChange={handleInputChange}
                  placeholder="Número do contrato"
                />
              </InputGroup>
              <InputGroup size="sm" className="dash-filter-input-group shadow-sm">
                <InputGroup.Text className="py-0 bg-light text-secondary"><FaIdCard size={12} /></InputGroup.Text>
                <Form.Control
                  size="sm"
                  type="text"
                  name="cnpj"
                  value={customFilter.cnpj}
                  onChange={handleInputChange}
                  placeholder="CNPJ"
                />
              </InputGroup>
              <InputGroup size="sm" className="dash-filter-input-group shadow-sm">
                <InputGroup.Text className="py-0 bg-light text-secondary"><FaBoxes size={12} /></InputGroup.Text>
                <Form.Control
                  size="sm"
                  type="text"
                  name="lote"
                  value={customFilter.lote}
                  onChange={handleInputChange}
                  placeholder="Número do lote"
                />
              </InputGroup>
              <InputGroup size="sm" className="dash-filter-input-group shadow-sm">
                <InputGroup.Text className="py-0 bg-light text-secondary"><FaTruck size={12} /></InputGroup.Text>
                <Form.Control
                  size="sm"
                  type="text"
                  name="placa"
                  value={customFilter.placa}
                  onChange={handleInputChange}
                  placeholder="Placa"
                />
              </InputGroup>
              <DashMedidasButton
                variant="success"
                onClick={handleApplyFilters}
                disabled={!permissionSGU?.home?.write}
                className="ms-lg-auto"
              >
                Aplicar filtros
              </DashMedidasButton>
            </div>
          </div>
        </Tab>
      </Tabs>
      </div>
      </DashMedidasSectionCard>
    </>
  );
};

export default InsertDate;
